import { createContext } from 'react';
import { SignalRProvider } from './SignalRProvider';

export const FlowSignalRConnectionContext = createContext();
export const FlowSignalRProvider = ({ children }) => (
  <SignalRProvider hubName="LessonHub" context={FlowSignalRConnectionContext}>
    {children}
  </SignalRProvider>
);
